<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="notification-panel" @notificationState *ngIf="state">
  <div class="d-flex align-items-center d-flex space-between">
    <div class="flex-grow-1 panel-title p">
      <h2> {{'notification-ui.title' | translate}} </h2>
    </div>
    <div class="flex-grow-0 p">
      <button pButton type="button" icon="ui-icon-clear"
              (click)="reset()" data-testid="reset-btn"></button>
    </div>

  </div>

  <div class="notification-container">
    <div *ngFor="let notification of notifications | async" (click)="onNotificationClick(notification)">
      <div class="notification p" [ngClass]="{'seen': notification.status==='SEEN'}"
           *ngIf="notification.deleted !== true">
        <div class="content">
          <h3 class="title"> {{notification.subject}} </h3>
          <p class="body" [innerHTML]="notification.content | safe: 'html'"></p>
        </div>
        <div class="action-wrapper">
          <button class="action" pButton type="button" icon="ui-icon-clear"
                  pTooltip="{{'notification-ui.delete' | translate}}"
                  tooltipPosition="left" positionStyle="fixed"
                  (click)="remove($event, notification)" data-testid="remove-btn"></button>
        </div>
      </div>
    </div>
  </div>


</div>
<div class="notification-overlay" (click)="reset()"></div>

